import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.3_@opentelemetry+api@1.9.0_eslint@8.57.1_rollup@4.18.0_sass@1.71.1_typescript@5.5.3_vite@5.3.3_vue-tsc@2.0.26/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}